
import { Component, Vue } from 'vue-property-decorator'

@Component({
  metaInfo() {
    return {
      title: '港联数字港口服务平台',
      meta: [
        {
          name: 'author',
          content: 'www.shiportunion.com'
        },
        {
          name: 'title',
          content: '港联数字港口服务平台'
        },
        {
          name: 'description',
          content: '港联数字港口服务平台是行业领先的港口数字服务平台'
        },
        {
          name: 'keywords',
          content: '港联,dps,港口,服务,数字化'
        },
        {
          name: 'robots',
          content: 'all'
        },
        {
          property: 'og:title',
          content: '港联数字港口服务平台'
        },
        {
          property: 'og:description',
          content: '港联数字港口服务平台是行业领先的港口数字服务平台'
        }
      ]
    }
  }
})
export default class App extends Vue {}
